const state = { password: null }

const getters = {
  password(state) {
    return state.password
  },
}

const mutations = {
  SET(state, password) {
    state.password = password
  },
  CLEAR(state) {
    state.password = null
  },
  // SendPasswordResetMail Mutationの呼び出し方
}

const actions = {
  applyPasswordReset({ commit }, password) {
    commit('SET', password)
  },
  initialize({ commit }) {
    commit('CLEAR')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
